import React, { useState } from "react";
import { db } from "../Config/Firebase"; //config file
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const AccountModal = () => {
  const [identifier, setIdentifier] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault(); 

    if (!identifier || !password) {
      alert("Please enter Email/Phone and Password");
      return;
    }

    setLoading(true);
    const auth = getAuth();

    try {
      let emailToCheck = null;

      //  Try with an email
      const q = query(collection(db, "users"), where("email", "==", identifier));
      let querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        // try with Phone number
        const q2 = query(collection(db, "users"), where("phone", "==", identifier));
        querySnapshot = await getDocs(q2);

        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          emailToCheck = userData.email; // get email
        }
      } else {
        emailToCheck = identifier;
      }

      if (!emailToCheck || querySnapshot.empty) {
        alert("No user found with this Email/Phone");
        setLoading(false);
        return;
      }

     
      await signInWithEmailAndPassword(auth, emailToCheck, password);

      // 3. Update user as blocked
      for (const docSnap of querySnapshot.docs) {
        const docId = docSnap.id;
        const userRef = doc(db, "users", docId);
        await updateDoc(userRef, { isBlocked: true });
      }
      setIdentifier("");
      setPassword("");
      alert("User authenticated & account deletion process started ✅");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex h-screen font-sans">
      {/* Left Side */}
      <div className="bg-red-500 flex justify-center items-center text-white w-1/2 Delete-left-side">
        <div className="text-center px-6">
          <h1 className="text-6xl font-bold">Heshe</h1>
          <p className="text-lg mt-2">Stop waiting for the right time. Start meeting the right people, right now</p>
        </div>
      </div>

      {/* Right Side */}
      <div className="flex justify-center items-center w-1/2 Delete-right-side bg-white">
        <div className="p-10 w-full max-w-md">
          <h1 className="text-red-600 text-5xl font-bold mb-2 text-center">Heshe</h1>
          <p className="text-lg mt-2 mb-10 text-center">Stop waiting for the right time. Start meeting the right people, right now</p>

          <h2 className="text-xl font-semibold mb-6 text-center">Delete Account</h2>

          
          <div className="md:bg-red-50 md:border md:border-red-200 md:rounded-lg p-4 mb-8 text-sm md:text-red-600">
            <p className="font-semibold mb-2">⚠️ Before you proceed:</p>
            <ul className="list-disc list-inside space-y-1 text-left">
              <li>Your profile will be permanently removed.</li>
              <li>All your matches and conversations will be deleted.</li>
              <li>You will not be able to recover your account later.</li>
            </ul>
          </div>

          {/* Form Section */}
          <form onSubmit={handleConfirm} className="flex flex-col space-y-6">
            {/* Email/Phone field */}
            <input
              type="text"
              placeholder="Email or Phone"
              className="border text-black rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 outline-none"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />

            {/* Password field */}
            <input
              type="password"
              placeholder="Password"
              className="border rounded-lg text-black px-4 py-2 focus:ring-2 focus:ring-red-500 outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
            >
              {loading ? "Processing..." : "Confirm Deletion"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountModal;
